import AppLayout from '../Layout/AppLayout';
import CheckIn from '../Components/CheckIn/CheckIn';

const CheckInPage = () => {
    return (
        <AppLayout>
            <CheckIn />
        </AppLayout>
    );
};

export default CheckInPage;
